import sanitizeHtml from 'sanitize-html';
import { pageContext } from './page_context';

const defaultAllowedHtmlTags = [
    'h2', 'h3', 'h4', 'a', 'span', 'p', 'br',
    'b', 'strong', 'i', 'em', 'sup', 'ul', 'li', 'ol'
];

/**
 * Sanitize innerHTML method
 * @param  {String} innerHtml - the innerHtml property.
 * @param  {Array} allowedTags - An array of allowed tags.
 * @returns {String} - sanitized innerHTML
 */
export const sanitizeInnerHtml = (innerHtml, allowedTags = defaultAllowedHtmlTags) => {
    return sanitizeHtml(replaceBaseUrl(innerHtml), {
        allowedTags,
        allowedAttributes: {
            a: ['href', 'target', 'data-id', 'style'],
            span: ['class'],
            p: ['data-id']
        }
    });
};

/**
 * Centralised functionality to perform a replace on /evt/assets path
 * @param {String} content The content that needs to have a replace
 * @param {String} baseUrl The base URL
 * @returns {String} The string or the string with /evt/assets replaced with the baseUrl
 */
export const replaceBaseUrl = (content, baseUrl = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath()) => {
    return typeof content === 'string' && content.indexOf(baseUrl) === -1 ? content.replace(/\/evt\/assets/g, baseUrl) : content;
};
